import Navbar from "../../components/common/NavBar";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { useAllFundsData } from "../../lib/hooks";
import { Alert, Grid } from "@mui/material";
import { FundCard, FundCardLoading } from "../../components/fund/FundCard";
import { Container } from "@mui/system";

const funds = [4, 5, 6, 7, 8, 9];
export default function FundIndex() {
  const {
    loading: funds_loading,
    fundsData,
    error: funds_error,
  } = useAllFundsData();

  return (
    <>
      <Navbar />
      <Header pageName="Funds" />
      {funds_loading && (
        <Container sx={{ pt: 8, paddingBottom: "100px" }}>
          <Grid container spacing={4} sx={{ justifyContent: "space-around" }}>
            {funds.map((item) => (
              <Grid xs={12} md={6} lg={4} item key={`funds-card-key-${item}`}>
                <FundCardLoading />
              </Grid>
            ))}
          </Grid>
        </Container>
      )}
      {!funds_loading && funds_error && (
        <div className="alertContainer">
          <Alert severity="error">{funds_error}</Alert>
        </div>
      )}
      {!funds_loading && funds_error === null && (
        <Container sx={{ pt: 8, paddingBottom: "100px" }}>
          <Grid container spacing={4} sx={{ justifyContent: "space-around" }}>
            {fundsData.map((item) => (
              <Grid
                xs={12}
                md={6}
                lg={4}
                item
                key={`funds-card-key-${item.fund_id}`}
              >
                <FundCard fundData={item} />
              </Grid>
            ))}
          </Grid>
        </Container>
      )}
      <Footer />
    </>
  );
}
